<template>
	<v-card class="elevation-3" color="white">
		<v-img class="white--text align-end mb-4" :src="tenant.settings.brandImages.dashboardImage.company">
			<div class="text-center ma-4 title">
				<h4>Do you need a locum for your practice?</h4>
			</div>

			<div class="text-center ma-1 pa-1">
				<v-row no-gutters>
					<v-col>
						<v-btn width="180px" rounded color="white" class="black--text mt-2" @click="gotoLocumSearch()">Find a Locum</v-btn>
					</v-col>
					<v-col>
						<v-btn width="180px" rounded color="white" class="black--text mt-2" @click="gotoSetAnOffer()">Set an Offer</v-btn>
					</v-col>
				</v-row>
				<v-row no-gutters justify="center">
					<v-col>
						<v-btn width="180px" rounded color="white" class="black--text mb-3 mt-2" @click="showFeaturedLocums()">Browse Locums</v-btn>
					</v-col>
				</v-row>
			</div>

			<!-- <div class="text-center ma-4 title">
				<h4>Do you need a permanent placement?</h4>
				<v-row no-gutters justify="center" class="mt-2">
					<v-col>
						<v-btn rounded color="white" class="black--text mb-3" @click="showFeaturedLocums()">Browse Locums</v-btn>
					</v-col>
				</v-row>
			</div> -->
		</v-img>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import { Tracking } from '@/utils';

export default {
	name: 'PracticeFindLocumCard',
	components: {},
	data: () => ({}),
	created() {},
	methods: {
		gotoLocumSearch() {
			//Private Offer
			Tracking.track('Practice_DashBoard_Find_A_Locum_Click', {});
			bus.$emit('change-context', 'practice-locum-search', 'Private');
		},
		gotoSetAnOffer() {
			//Public Offer
			Tracking.track('Practice_DashBoard_Set_An_Offer_Click', {});
			bus.$emit('change-context', 'practice-locum-search', 'Public');
		},
		showFeaturedLocums() {
			bus.$emit('show-featured-popup');
			Tracking.track('Prac_BrowseLocums_Click');
		},
	},
};
</script>
